// extracted by mini-css-extract-plugin
module.exports = {"productList":"product-list_productList_3sJ9u"};